var _rect, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFloorplanDefaultHover(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3.41028,
    y: 3.4707,
    width: 17.0557,
    height: 17.0557,
    rx: 1.5,
    stroke: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.91028 9.76955C3.91028 9.76955 7.57987 9.76955 9.93118 9.76955M9.93118 9.76955L9.93118 11.9995M9.93118 9.76955L9.93118 7.98558",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1981 3.9707V7.98463V11.9986",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0895 16.5122H20.5895V15.5122H20.0895V16.5122ZM9.9292 15.5122C9.65306 15.5122 9.4292 15.7361 9.4292 16.0122C9.4292 16.2883 9.65306 16.5122 9.9292 16.5122V15.5122ZM20.0895 15.5122H9.9292V16.5122H20.0895V15.5122Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFloorplanDefaultHover);
export default __webpack_public_path__ + "static/media/floorplan-default-hover.7a94008cf46a94f5105406e219890774.svg";
export { ForwardRef as ReactComponent };